/* eslint-disable no-restricted-globals */

const workercode = () => {
  let timer = 0;
  let interval;

  self.onmessage = function (e) {
    const { type } = e.data;

    if (type === 'START') {
      if (!interval) {
        interval = setInterval(() => {
          timer += 1;
          postMessage({ time: timer });
        }, 100);
      }
    } else if (type === 'RESET') {
      clearInterval(interval);
      interval = null;
      timer = 0;
      postMessage({ time: timer });
    } else if (type === 'KEEP_ALIVE') {
      // Perform a task to keep the worker alive
      (function () {
        // Perform a task to keep the worker alive
      })();
    }
  };
};

let code = workercode.toString();
code = code.substring(code.indexOf('{') + 1, code.lastIndexOf('}'));

const blob = new Blob([code], { type: 'application/javascript' });
export const timer_worker =
  typeof URL.createObjectURL === 'function' ? URL.createObjectURL(blob) : 'objectURL';
